import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Label, Button } from 'fw/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import * as Formatting from 'fw/misc/Formatting';
import BusinessCertificationsPopUp from '../popups/BusinessCertificationsPopUp';
import BUSINESS_CERTIFICATION_TYPES from '../../shared/BusinessCertificationTypes';

// NVBDC-1404 — read-only 9-item summary + one pencil icon opening the popup editor.
class BusinessCertificationSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showPopUp: false };
    }

    open = () => this.setState({ showPopUp: true });
    close = () => this.setState({ showPopUp: false });

    onSave = (form) => {
        this.props.onChange({ ...this.props.businessCertification, ...form });
    };

    // Date-only (Formatting.formatDate), not the raw ISO datetime string (which was rendering as
    // e.g. "2026-07-31T00:00:00") — and on its own line below the label instead of inline, so the
    // trailing " — " before "expires" can't wrap to its own line and look like a stray dash.
    renderDetail = (field) => {
        const expirationDate = this.props.businessCertification[`${field}ExpirationDate`];
        const fileName = this.props.businessCertification[`${field}FileName`];

        if (!expirationDate && !fileName) return null;

        return (
            <React.Fragment>
                <br />
                <small className="one-sheet-cert-detail">
                    {expirationDate && <React.Fragment>Expires: {Formatting.formatDate(expirationDate)}</React.Fragment>}
                    {expirationDate && fileName && ' — '}
                    {fileName}
                </small>
            </React.Fragment>
        );
    };

    render() {
        const cer = this.props.businessCertification;
        if (!cer) return null;

        return (
            <div>
                <Row>
                    <Col md={11}>
                        <Label>Do you have any of these Business Certifications?</Label>
                    </Col>
                    <Col md={1}>
                        <Button id="btnEditBusinessCertifications" bsStyle="link" onClick={this.open}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </Col>
                </Row>
                {BUSINESS_CERTIFICATION_TYPES.map(({ field, label }) => (
                    <p key={field}>
                        <span className={`label label-${cer[field] ? 'success' : 'danger'} one-sheet-yn-badge`}>{cer[field] ? 'YES' : 'NO'}</span>
                        {' '}{label}
                        {cer[field] && this.renderDetail(field)}
                    </p>
                ))}
                <p key="none">
                    <span className={`label label-${cer.none ? 'success' : 'danger'} one-sheet-yn-badge`}>{cer.none ? 'YES' : 'NO'}</span>
                    {' '}None of the above
                </p>

                <BusinessCertificationsPopUp
                    visible={this.state.showPopUp}
                    {...cer}
                    onSave={this.onSave}
                    onClose={this.close}
                />
            </div>
        );
    }
}

export default BusinessCertificationSection;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/sections/BusinessCertificationSection.js